import React, { useState } from "react";

import { isEmpty } from "ramda";

import { Pane, Typography } from "clearsense-ui/components";

import ConversionData from "./ConversionData";
import Converter from "./Converter";

const NewFHIRConversion = ({
  isNewFHIRConversionOpen,
  setIsNewFHIRConversionOpen,
}) => {
  const [selectedConverter, setSelectedConverter] = useState({});
  const [fhirDetails, setFHIRDetails] = useState({});

  const handleCancel = () => {
    setIsNewFHIRConversionOpen(false);
    setSelectedConverter({});
  };

  const onClose = () => {
    setIsNewFHIRConversionOpen(false);
    setSelectedConverter({});
    setTimeout(() => window.location.reload(), 2000);
  };

  return (
    <Pane size="md" isOpen={isNewFHIRConversionOpen} onClose={onClose}>
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          New FHIR Conversion
        </Typography>
      </Pane.Header>
      {isEmpty(selectedConverter) ? (
        <Converter
          setSelectedConverter={setSelectedConverter}
          handleCancel={handleCancel}
          setFHIRDetails={setFHIRDetails}
        />
      ) : (
        <ConversionData
          selectedConverter={selectedConverter}
          setSelectedConverter={setSelectedConverter}
          handleCancel={handleCancel}
          setFHIRDetails={setFHIRDetails}
          fhirDetails={fhirDetails}
          onClose={onClose}
        />
      )}
    </Pane>
  );
};

export default NewFHIRConversion;
